(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b4s-bike-finder"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = document.querySelector('[data-b4s-bike-finder]');
    if (!root) return;
    var productsNode = root.querySelector('[data-b4s-products]');
    var productData = JSON.parse(productsNode.textContent || '[]');
    var uniqueProductIds = {};
    var products = productData.filter(function (product) {
      if (product.available !== true || product.inStock !== true) return false;
      if (uniqueProductIds[product.id]) return false;
      uniqueProductIds[product.id] = true;
      return true;
    }).map(function (product) {
      product.price = Number(product.price);
      product.minHeight = Number(product.minHeight);
      product.maxHeight = Number(product.maxHeight);
      return product;
    });
    var labels = { racer: 'racercykler', gravel: 'gravel-/crosscykler', mtb: 'mountainbikes', el: 'elcykler', tt: 'TT-/triathloncykler' };
    var singularLabels = { racer: 'racercykel', gravel: 'gravel-/crosscykel', mtb: 'mountainbike', el: 'elcykel', tt: 'TT-/triathloncykel' };
    var collectionHandles = { racer: 'alle-racercykler', gravel: 'alle-gravel-cross-cykler', mtb: 'alle-mountainbikes', el: 'alle-el-cykler', tt: 'alle-tt-triathloncykler' };
    var state = { type: '', height: 0, condition: 'alle', budget: 'alle', showAll: false };
    var typeButtons = root.querySelectorAll('[data-b4s-type]');
    var heightInput = root.querySelector('[data-b4s-height]');
    var error = root.querySelector('[data-b4s-error]');
    var results = root.querySelector('[data-b4s-results]');
    var title = root.querySelector('[data-b4s-results-title]');
    var copy = root.querySelector('[data-b4s-results-copy]');
    var content = root.querySelector('[data-b4s-result-content]');
    var filters = root.querySelector('[data-b4s-filters]');
    function money(value) { return value.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr.'; }
    function escapeHtml(value) { var div = document.createElement('div'); div.textContent = value || ''; return div.innerHTML; }
    function exactMatch(product) { return state.height >= product.minHeight && state.height <= product.maxHeight; }
    function distanceOutside(product) { if (state.height < product.minHeight) return product.minHeight - state.height; if (state.height > product.maxHeight) return state.height - product.maxHeight; return 0; }
    function matchesCurrentFilters(product) {
      if (product.type !== state.type) return false;
      if (state.condition !== 'alle' && product.condition !== state.condition) return false;
      if (state.budget === 'under-10000') return product.price < 10000;
      if (state.budget === '10000-25000') return product.price >= 10000 && product.price <= 25000;
      if (state.budget === '25000-50000') return product.price >= 25000 && product.price <= 50000;
      if (state.budget === 'over-50000') return product.price > 50000;
      return true;
    }
    function productCard(product, nearest) {
      var note = nearest ? 'Du ligger ' + distanceOutside(product) + ' cm ' + (state.height < product.minHeight ? 'under' : 'over') + ' producentens interval.' : 'Din højde ligger i producentens anbefalede interval.';
      return '<a class="b4s-bike-finder__card" href="' + escapeHtml(product.url) + '"><img src="' + escapeHtml(product.image) + '" alt=""><div class="b4s-bike-finder__card-body"><h3 class="b4s-bike-finder__card-title">' + escapeHtml(product.title) + '</h3><p class="b4s-bike-finder__card-price">' + money(product.price) + '</p><span class="b4s-bike-finder__range">' + product.minHeight + '–' + product.maxHeight + ' cm · ' + escapeHtml(note) + '</span></div></a>';
    }
    function selectPriceSpread(items) {
      if (items.length <= 5) return items;
      var positions = [0, 0.25, 0.5, 0.75, 1];
      var selectedIndexes = positions.map(function (position) {
        return Math.round((items.length - 1) * position);
      }).filter(function (index, position, all) {
        return all.indexOf(index) === position;
      });
      return selectedIndexes.map(function (index) { return items[index]; });
    }
    function updateUrl() {
      var url = new URL(window.location.href);
      url.searchParams.set('type', state.type);
      url.searchParams.set('height', String(state.height));
      if (state.condition !== 'alle') url.searchParams.set('condition', state.condition); else url.searchParams.delete('condition');
      window.history.replaceState({}, '', url.toString());
    }
    function collectionLink() {
      var handle = collectionHandles[state.type];
      if (!handle) return '';
      return '<a class="b4s-bike-finder__collection-link" href="/collections/' + handle + '?height=' + encodeURIComponent(state.height) + '">Se hele udvalget af ' + labels[state.type] + ' i min størrelse <span aria-hidden="true">→</span></a>';
    }
    function render(shouldScroll) {
      var typeProducts = products.filter(function (product) { return product.type === state.type; });
      var exact = typeProducts.filter(exactMatch);
      var visibleExact = exact.filter(matchesCurrentFilters).sort(function (a, b) { return a.price - b.price; });
      results.hidden = false;
      if (exact.length) {
        title.textContent = visibleExact.length + ' cykler i din anbefalede størrelse';
        copy.textContent = 'Din højde på ' + state.height + ' cm ligger inden for producentens interval på disse ' + labels[state.type] + '.';
        filters.hidden = false;
        if (visibleExact.length) {
          var featured = state.showAll ? visibleExact : selectPriceSpread(visibleExact);
          var intro = visibleExact.length > featured.length
            ? '<p class="b4s-bike-finder__selection-note">Vi viser fem gode størrelsesmatches fordelt over prisniveauerne, så du hurtigt kan sammenligne uden at skulle gennem en lang liste.</p>'
            : '';
          var more = '';
          if (visibleExact.length > 5) {
            more = '<button class="b4s-bike-finder__more" type="button" data-b4s-show-all>' + (state.showAll ? 'Vis færre cykler' : 'Se alle ' + visibleExact.length + ' matches') + '</button>';
          }
          content.innerHTML = intro + collectionLink() + '<div class="b4s-bike-finder__grid">' + featured.map(function (product) { return productCard(product, false); }).join('') + '</div>' + more;
          var moreButton = content.querySelector('[data-b4s-show-all]');
          if (moreButton) {
            moreButton.addEventListener('click', function () {
              state.showAll = !state.showAll;
              render(false);
            });
          }
        } else {
          content.innerHTML = '<div class="b4s-bike-finder__empty"><h3>Ingen match med de valgte filtre</h3><p>Der er cykler i din størrelse, men ingen passer til den stand eller pris, du har valgt. Prøv at udvide filtrene.</p></div>';
        }
      } else {
        title.textContent = 'Vi har ikke en ' + singularLabels[state.type] + ' i præcis din anbefalede størrelse lige nu';
        copy.textContent = 'Din højde på ' + state.height + ' cm ligger ikke inden for producentens interval på de cykler, vi har på lager i denne kategori.';
        filters.hidden = true;
        var nearest = typeProducts.slice().sort(function (a, b) { return distanceOutside(a) - distanceOutside(b) || a.price - b.price; }).slice(0, 3);
        content.innerHTML = '<div class="b4s-bike-finder__empty"><h3>Få personlig vejledning, før du vælger</h3><p>Vi vil hellere være ærlige end vise dig en cykel, som ikke passer. Kontakt os, så hjælper vi med den rigtige størrelse eller holder øje med næste match.</p><div class="b4s-bike-finder__contact"><a href="tel:+4525786370">Ring 25 78 63 70</a><a href="mailto:kontakt@bike4sport.dk?subject=Hjælp%20til%20cykelstørrelse">Skriv til os</a></div></div>' + (nearest.length ? '<h3 class="b4s-bike-finder__nearest-title">Nærmeste størrelser</h3><p class="b4s-bike-finder__nearest-note">De er ikke direkte matches — derfor viser vi præcis, hvor langt du ligger fra intervallet.</p><div class="b4s-bike-finder__grid">' + nearest.map(function (product) { return productCard(product, true); }).join('') + '</div>' : '');
      }
      updateUrl();
      if (shouldScroll !== false) results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    function submit() {
      var height = Number.parseInt(heightInput.value, 10);
      error.textContent = '';
      if (!state.type) { error.textContent = 'Vælg først den type cykel, du leder efter.'; return; }
      if (!Number.isInteger(height) || height < 100 || height > 220) { error.textContent = 'Indtast din højde som et tal mellem 100 og 220 cm.'; return; }
      state.height = height;
      state.showAll = false;
      if (window.Bike4SportSizeProfile) {
        window.Bike4SportSizeProfile.save(height);
      }
      render();
    }
    typeButtons.forEach(function (button) { button.addEventListener('click', function () { state.type = button.dataset.b4sType; typeButtons.forEach(function (item) { item.classList.toggle('is-active', item === button); }); error.textContent = ''; }); });
    root.querySelector('[data-b4s-submit]').addEventListener('click', submit);
    heightInput.addEventListener('keydown', function (event) { if (event.key === 'Enter') submit(); });
    root.querySelectorAll('[data-b4s-condition]').forEach(function (button) { button.addEventListener('click', function () { state.condition = button.dataset.b4sCondition; state.showAll = false; root.querySelectorAll('[data-b4s-condition]').forEach(function (item) { item.classList.toggle('is-active', item === button); }); render(); }); });
    root.querySelector('[data-b4s-budget]').addEventListener('change', function (event) { state.budget = event.target.value; state.showAll = false; render(); });
    root.querySelector('[data-b4s-reset]').addEventListener('click', function () { state.type = ''; state.height = 0; state.condition = 'alle'; state.budget = 'alle'; state.showAll = false; heightInput.value = ''; results.hidden = true; typeButtons.forEach(function (item) { item.classList.remove('is-active'); }); var url = new URL(window.location.href); ['type','height','condition'].forEach(function (key) { url.searchParams.delete(key); }); window.history.replaceState({}, '', url.toString()); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
    var query = new URLSearchParams(window.location.search);
    var queryType = query.get('type');
    var queryHeight = Number.parseInt(query.get('height'), 10);
    var queryCondition = query.get('condition');
    if (labels[queryType]) { state.type = queryType; typeButtons.forEach(function (button) { button.classList.toggle('is-active', button.dataset.b4sType === state.type); }); }
    if (['ny','brugt'].includes(queryCondition)) { state.condition = queryCondition; root.querySelectorAll('[data-b4s-condition]').forEach(function (button) { button.classList.toggle('is-active', button.dataset.b4sCondition === state.condition); }); }
    if (Number.isInteger(queryHeight) && queryHeight >= 100 && queryHeight <= 220) { heightInput.value = String(queryHeight); if (state.type) { state.height = queryHeight; render(); } }
    if (!heightInput.value && window.Bike4SportSizeProfile) {
      var savedHeight = window.Bike4SportSizeProfile.read();
      if (savedHeight) heightInput.value = String(savedHeight);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["service-list"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function fmt(n) {
    return Math.round(n).toLocaleString('da-DK');
  }

  function uniqueRef() {
    return 'SRV' + Date.now();
  }

  function updateEstimate() {
    var checkboxes = document.querySelectorAll('.service-checkbox:checked');
    var totalArbejde = 0;

    checkboxes.forEach(function (cb) {
      var timer = parseFloat(cb.dataset.timer) || 0;
      var timepris = parseFloat(cb.dataset.timepris) || 0;
      totalArbejde += timer * timepris;
    });

    document.getElementById('est-arbejde').textContent = fmt(totalArbejde) + ' kr';
    document.getElementById('est-total').textContent = fmt(totalArbejde) + ' kr';
  }

  function initTermsScroll() {
    var termsEl = document.getElementById('service-terms-scroll');
    var acceptCb = document.getElementById('terms-accept');
    if (!termsEl || !acceptCb) return;

    function checkScroll() {
      var atBottom = termsEl.scrollTop + termsEl.clientHeight >= termsEl.scrollHeight - 8;
      if (atBottom) {
        acceptCb.disabled = false;
        acceptCb.closest('label').classList.add('is-enabled');
        termsEl.removeEventListener('scroll', checkScroll);
        termsEl.removeEventListener('keyup', checkScroll);
      }
    }

    termsEl.addEventListener('scroll', checkScroll);
    termsEl.addEventListener('keyup', checkScroll);
    checkScroll();
  }

  function initSubmitToggle() {
    var acceptCb = document.getElementById('terms-accept');
    var submitBtn = document.getElementById('service-submit-btn');
    if (!submitBtn) return;

    if (!acceptCb) {
      submitBtn.disabled = false;
      submitBtn.removeAttribute('aria-disabled');
      return;
    }

    acceptCb.addEventListener('change', function () {
      submitBtn.disabled = !acceptCb.checked;
      submitBtn.setAttribute('aria-disabled', String(!acceptCb.checked));
    });
  }

  function buildMailto(ref) {
    var adminEmail = (document.querySelector('meta[name="service-admin-email"]') || {}).content || '';
    var checkboxes = document.querySelectorAll('.service-checkbox:checked');
    var serviceLines = [];
    var totalTimer = 0, totalArbejde = 0;

    checkboxes.forEach(function (cb) {
      var timer = parseFloat(cb.dataset.timer) || 0;
      var timepris = parseFloat(cb.dataset.timepris) || 0;
      totalTimer += timer;
      totalArbejde += timer * timepris;
      serviceLines.push('- ' + cb.value + ' (' + timer + ' t @ ' + timepris + ' kr/t)');
    });

    var serviceNames = Array.from(checkboxes).map(function (cb) { return cb.value; }).join(', ');
    var navn = (document.getElementById('sf-navn') || {}).value || '';
    var telefon = (document.getElementById('sf-telefon') || {}).value || '';
    var email = (document.getElementById('sf-email') || {}).value || '';
    var cykelModel = (document.getElementById('sf-cykel-model') || {}).value || '';
    var cykelAargang = (document.getElementById('sf-cykel-aargang') || {}).value || '';
    var udstyr = (document.getElementById('sf-udstyr') || {}).value || '';
    var tidspunkt = (document.getElementById('sf-tidspunkt') || {}).value || '';

    var subject = 'Forespørgsel service: ' + serviceNames + ' — ' + cykelModel + ' ' + cykelAargang + ' — Ref:' + ref;

    var body = [
      '=== SERVICEFORESPØRGSEL ===',
      'Reference: ' + ref,
      '',
      '--- VALGTE YDELSER ---',
      serviceLines.join('\n'),
      '',
      'Samlet estimeret arbejdstid: ' + totalTimer + ' t',
      'Estimeret arbejdspris: ' + fmt(totalArbejde) + ' kr',
      '',
      'NB: Pris på komponenter og materialer aftales individuelt efter vurdering.',
      '',
      '--- KUNDEOPLYSNINGER ---',
      'Navn: ' + navn,
      'Telefon: ' + telefon,
      'E-mail: ' + email,
      '',
      '--- CYKEL ---',
      'Model: ' + cykelModel,
      'Årgang: ' + cykelAargang,
      'Udstyr / noter: ' + (udstyr || '–'),
      '',
      '--- ØNSKET TIDSPUNKT ---',
      tidspunkt || '–',
      '',
      '---',
      'Vi svarer inden for 24 timer på hverdage.',
    ].join('\n');

    return 'mailto:' + encodeURIComponent(adminEmail)
      + '?subject=' + encodeURIComponent(subject)
      + '&body=' + encodeURIComponent(body);
  }

  function initForm() {
    var form = document.getElementById('service-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var checkboxes = document.querySelectorAll('.service-checkbox:checked');
      if (checkboxes.length === 0) {
        alert('Vælg mindst én serviceydelse.');
        return;
      }
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }
      var ref = uniqueRef();
      window.location.href = buildMailto(ref);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.service-checkbox').forEach(function (cb) {
      cb.addEventListener('change', updateEstimate);
    });
    initTermsScroll();
    initSubmitToggle();
    initForm();
    updateEstimate();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
